import { Component, ChangeDetectionStrategy, input, output, model, computed, signal, inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { CartItem } from '../../types/product';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '@/src/services/authentication.service';
import { MasterService } from '@/src/services/master.service';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
@Component({
  selector: 'app-cart',
  standalone: true,
  imports: [CurrencyPipe, TranslateModule, CommonModule, SelectModule, FormsModule, InputNumberModule],
  templateUrl: './cart.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col h-full'
  },
  styleUrl: '../cart/cart.component.css'
})
export class CartComponent {
  auth = inject(AuthenticationService);
  masterService = inject(MasterService);
  translate = inject(TranslateService)
  cdr = inject(ChangeDetectorRef)
  cart = input.required<CartItem[]>();
  DISCOUNT_AMT = input(0);
  paymentReservation = input(false);
  isMobileCartExpanded = model.required<boolean>();
  viewMode = input.required<'register' | 'payment'>();
  openUserSearch = signal(false);

  updateQuantity = output<{ product: any, delta: number }>();
  updateQuantityInput = output<{ product: any, delta: number }>();
  removeFromCart = output<string>();
  removeAllFromCart = output<boolean>();
  cancelPaymentReservation = output<boolean>();
  goToPayment = output<void>();
  selectedUser = output<string>();

  subtotal = computed(() => this.cart().reduce((sum, item) => sum + (item.price * item.quantity), 0));
  total = computed(() => this.subtotal());
  totalQuantity = computed(() => this.cart().reduce((acc, i) => acc + i.quantity, 0));
  totalPayment = computed(() => this.total() - this.DISCOUNT_AMT());

  ngOnInit() {
    this.getUserInfo();
  }

  getUserInfo() {
    this.masterService.getUserInfo().subscribe((res: any) => {
      if (res?.isOK) {
        const data = res?.result?.dataRes[0]?.rows[0]
        this.selectedmember = data?.useR_NM;
        this.cdr.detectChanges();
      }
    })
  }

  onUpdateQuantity(product: any, delta: number) {
    delta = delta > 99 ? 99 : delta;
    this.updateQuantity.emit({ product, delta });
  }

  onUpdateQtyInqut(product: any, event: any) {
    if (event) {
      const delta: number = event
      this.updateQuantityInput.emit({ product, delta });
    }
  }

  onRemoveFromCart(product: any) {
    this.removeFromCart.emit(product);
  }

  onRemoveAllCart() {
    this.removeAllFromCart.emit(true);
  }

  onCancelPaymentReservation() {
    this.cancelPaymentReservation.emit(true);
  }

  onGoToPayment() {
    this.goToPayment.emit();
  }

  userList = new Array();
  selectedStaff: any;
  getUser() {
    const param = {
      P_HQ_CD: this.auth.getHQCD(),
      P_STR_CD: this.auth.getStrCd(),
      P_TEL_NO: '',
      P_USER_NM: ''
    }
    //SP_STR_GET_USER_LIST
    this.masterService.excute_sp('6a83a011-298d-11f1-9014-00155d001e02', param).subscribe((res: any) => {
      if (res?.isOK) {
        this.userList = res?.result?.dataRes[0]?.rows?.filter((x : any) => x.retirE_FG != '2')
        this.openUserSearch.set(true)

        this.selectedStaff = this.userList.find(x => x.useR_NM === this.selectedmember);
        // this.op.toggle(event);
      }
    })
  }
  // @ViewChild('op') op: any;
  toggle(event : any) {
    this.getUser();
  }
  selectedmember = '';
  isErrorSaveStaff: boolean = false;
  onChangeSelectStaff() {
    if (this.selectedStaff) {
      this.isErrorSaveStaff = false;
    }
  }
  selectMember() {
    if (this.selectedStaff) {
      this.isErrorSaveStaff = false;
      this.selectedmember = this.selectedStaff?.useR_NM;
      this.selectedUser.emit(this.selectedStaff?.useR_ID);
      this.openUserSearch.set(false)
      this.masterService.showSuccess(this.translate.instant('PAYMESTR0066'))
      this.selectedStaff = null;
    }
    else this.isErrorSaveStaff = true;
    // this.op.hide();
  }

  onClose() {
    this.isErrorSaveStaff = false;
    this.openUserSearch.set(false)
  }
}